/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qk_TypeInputs */

const en_qk_type = /** @type {(inputs: Qk_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item type`)
};

const de_qk_type = /** @type {(inputs: Qk_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgangstyp`)
};

/**
* | output |
* | --- |
* | "Item type" |
*
* @param {Qk_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const qk_type = /** @type {((inputs?: Qk_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qk_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_qk_type(inputs)
	return en_qk_type(inputs)
});